import { Chip } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { IUserResult } from 'src/types/user';
import { fDate } from 'src/utils/format-time';

// ----------------------------------------------------------------------

type Props = {
  selected: boolean;
  onEditRow: VoidFunction;
  row: IUserResult;
  onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  id: any;
};

export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  id,
}: Props) {
  return (
    <TableRow hover selected={selected}>
      {/* <TableCell padding="checkbox">
        <Checkbox checked={selected} onClick={onSelectRow} />
      </TableCell> */}

      <TableCell
        sx={{
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
        onClick={onEditRow}
      >
        {'phone_number' in row && row?.phone_number}
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap' }}>
        {'role' in row && <Chip color="primary" size="small" label={row.role?.role} />}
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap' }}>
        {'restaurants' in row &&
          row.restaurants?.map((restaurant, index) => {
            if (index < 2) {
              return restaurant.name_en;
            }
            if (index === 2) {
              return '...';
            }
            return '';
          }).join(', ')}
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap' }}>
        {'permissions' in row && row.permissions?.length}
      </TableCell>

      {'created_at' in row && (
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{fDate(row.created_at)}</TableCell>
      )}

      {'updated_at' in row && (
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{fDate(row.updated_at)}</TableCell>
      )}
    </TableRow>
  );
}
